import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import { Button } from '@mantine/core';
import { IconSparkles } from '@tabler/icons-react';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { useOpenIngestion } from '../useOpenIngestion';

/** Entry point on the empty Transactions state, next to the existing upload / add buttons. */
export const ExtractFromDocumentButton = () => {
	const tCapManage = useTranslationCapManage();
	const openIngestion = useOpenIngestion();

	return (
		<Button
			size="height-36"
			variant="default"
			leftSection={<IconSparkles size={16} stroke={1.5} />}
			onClick={openIngestion}
			data-testid={TEST_ELEMENT_IDS.DEALSTACK_AI_INGEST_EXTRACT_FROM_DOCUMENT_BUTTON}
		>
			{tCapManage('dealstack_ai.ingest.entry.extract_from_document')}
		</Button>
	);
};
